<div class="container">
  <div class="row justify-content-center py-5 align-items-center">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-4">
          <div class="row">
            <div class="col-sm-6">
              <h2 class="card-title mb-4">Informations</h2>
            </div>
            <div class="col-sm-6">
              <button class="btn btn-lg btn-secondary btn-block w-100" (click)="onLogout()">
                Déconnexion
              </button>
            </div>
          </div>
          <div class="mb-4">
            <p class="mb-2">
              <strong>Nom :</strong>
              {{ pickupService.getPickup()!.name }}
            </p>
            <p class="mb-2">
              <strong>Adresse :</strong>
              {{ pickupService.getPickup()!.route }} {{ pickupService.getPickup()!.postalCode }} {{ pickupService.getPickup()!.locality }}
            </p>
            <p class="mb-2" *ngIf="pickupService.getPickup()!.pickupOwner">
              <strong>Informations de contact :</strong>
              {{ pickupService.getPickup()!.pickupOwner!.firstName }} {{ pickupService.getPickup()!.pickupOwner!.lastName }} {{ pickupService.getPickup()!.pickupOwner!.email }} {{ pickupService.getPickup()!.pickupOwner!.phoneNumber }}
            </p>
            <p class="mb-2" *ngIf="pickupService.getPickup()!.pickupOwner">
              <strong>ARS UNIQUEMENT (<u>sauf Fi</u>) :</strong> Envoyer de la PLV (uniquement pour le premier lot de kits) :
              <ng-container *ngIf="pickupService.getPickup()!.pickupOwner!.advertising">
                oui
              </ng-container>
              <ng-container *ngIf="!pickupService.getPickup()!.pickupOwner!.advertising">
                non
              </ng-container>
            </p>
            <button class="btn btn-primary btn-lg w-100" (click)="onShowPickupOwnerModal()">
              Modifier mes informations de contact
            </button>
          </div>
          <div class="row">
            <div class="col-sm-4 p-2">
              <button class="btn btn-primary btn-lg w-100" (click)="onCreateKitBatch(15,10)">
                15 DRAPS 10 COUETTES
              </button>
            </div>
            <div class="col-sm-4 p-2">
            </div>
            <div class="col-sm-4 p-2">
              <button class="btn btn-primary btn-lg w-100" [disabled]="!hasAlreadyReceivedAnOrder()" (click)="onCreateKitBatch(5,20)">
                5 DRAPS 20 COUETTES
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center py-5 align-items-center">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-4">
          <h2 class="card-title mb-4">Historique de commande</h2>
          <div class="d-none d-md-block">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Date</th>
                <th scope="col">Type</th>
                <th scope="col">Status</th>
                <th class="w-1/2" scope="col">Suivi</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let order of orderList">
                <th scope="row" class="align-content-center">{{ order.id }}</th>
                <td class="align-content-center">{{ order.createdAt | date:'d/M/yy, H:mm' }}</td>
                <td class="align-content-center">
                  <ng-container *ngFor="let orderKit of order.orderKitList">
                    {{ orderKit.quantity / PRICEMULTIPLIER }} {{ orderKit.name }}
                  </ng-container>
                </td>
                <td class="align-content-center">{{ order.status | orderStatus }}</td>
                <td class="align-content-center">
                  <ng-container *ngFor="let ref of trackingRefsMap[order.id]; let last = last">
                    <a target="_blank" rel="noopener" [href]="ref | chronopostTrackingUrl">{{ ref }}</a>
                    <ng-container *ngIf="!last">, </ng-container>
                  </ng-container>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-md-none" *ngFor="let order of orderList">
            <div class="card m-2">
              <div class="card-body">
                <h5 class="card-title">ID #{{ order.id }} {{ order.status | orderStatus }}</h5>
                <p class="card-text">
                  {{ order.createdAt | date:'d/M/yy, H:mm' }}<br/>
                  <ng-container *ngFor="let orderKit of order.orderKitList">
                    {{ orderKit.quantity / PRICEMULTIPLIER }} {{ orderKit.name }}
                  </ng-container>
                  <br/>
                  <ng-container *ngIf="trackingRefsMap[order.id]?.length">
                    <strong>Suivi :</strong>
                    <ng-container *ngFor="let ref of trackingRefsMap[order.id]; let last = last">
                      <a target="_blank" rel="noopener" [href]="ref | chronopostTrackingUrl">{{ ref }}</a>
                      <ng-container *ngIf="!last">, </ng-container>
                    </ng-container>
                    <br/>
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



